import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { ListManufacturersQuery, Manufacturer } from './Manufacturers.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/manufacturers`;

export async function listManufacturers(
  params: ListManufacturersQuery,
): Promise<PageResult<Manufacturer>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Manufacturer>;
}

export async function getManufacturer(manufacturerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${manufacturerId}`,
    {},
  )) as unknown;

  return result as Manufacturer;
}
export async function detailManufacturers(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Manufacturer;
}

export async function statusManufacturers(
  manufacturerId: number,
  active: boolean,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${manufacturerId}/status?active=${active}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
